export const PLACEMENTS = [
  { value: "profileScreenBanner", label: "Profile screen banner" },
  { value: "contactScreenTopBanner", label: "Contact screen top banner" },
  { value: "matchRewarded", label: "Match rewarded" },
  { value: "matchingSwipeCard", label: "Matching swipe card" },
];

export const placementLabel = (value) =>
  PLACEMENTS.find((placement) => placement.value === value)?.label || value;
